import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLikesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#333"
      d="M18.782 10.528a3.123 3.123 0 0 0 .633-1.886c0-1.09-.609-2.12-1.59-2.696a1.642 1.642 0 0 0-.832-.226h-5.82l.146-2.982A2.598 2.598 0 0 0 10.603.81 2.588 2.588 0 0 0 8.713 0C7.45 0 6.334.85 5.999 2.065L3.915 9.613H.777A.776.776 0 0 0 0 10.39v8.833c0 .43.347.777.777.777h14.592c.224 0 .442-.044.644-.131a3.12 3.12 0 0 0 1.769-3.771 3.123 3.123 0 0 0 .502-2.784 3.123 3.123 0 0 0 .634-1.886 3.315 3.315 0 0 0-.136-.9ZM1.747 18.253V11.36h1.966v6.893H1.747Zm15.445-8.567-.531.46.337.617a1.386 1.386 0 0 1-.308 1.706l-.532.462.338.616a1.386 1.386 0 0 1-.308 1.706l-.532.461.337.617a1.38 1.38 0 0 1-.648 1.92H5.266v-6.968l2.415-8.75a1.07 1.07 0 0 1 1.024-.783c.185 0 .367.053.512.162.24.18.37.452.355.74l-.233 4.816h7.63c.432.264.699.71.699 1.174 0 .4-.175.78-.476 1.044Z"
    />
  </svg>
);
export default SvgLikesIcon;
